import { createElement } from 'react';
import ActionButton from 'components/ActionButton';

import { view } from './TriggerField.less';

const NumberField = ({ editing, input, meta, localeMessage, setValueTo = true, ...other }) =>
  editing
    ? createElement(ActionButton, {
        className: view,
        value: input.value,
        onClick: () => input.onChange(setValueTo),
        ...other,
      })
    : null;

export default NumberField;
